<template>
  <Content :button-create-show="true" link="/publication/create">
    <template #body>
      <Table
        v-if="filtersReady"
        :columns="columns"
        :options="columnsOptions"
        :method-fetch-data="methods.fetchData"
        :method-delete-rows="methods.deleteData"
      />
    </template>
  </Content>
</template>

<script>
import Table from "@/components/Table";
import Content from "@/layout/Content";

import { getPublications, deletePublication } from "@/api/publication";
import { getSiteSections } from "@/api/siteSection";
import { getDigests } from "@/api/digest";

const columnsOptions = {
  sortable: true,
  itemsName: "items",
  controls: true,
  editable: true,
  id: "id",
  search_list: [
    { label: "ID новости", name: "publication_id", strong: true },
    { label: "Заголовок", name: "title", strong: false },
    { label: "Текст", name: "content", strong: false },
    { label: "Раздел", name: "site_section_id", strong: true },
    { label: "Дайджест", name: "digest_id", strong: true },
    {
      label: "Дата создания",
      name: ["created_at_start", "created_at_end"],
      format: "datetimerange",
    },
  ],
};

const columns = [
  { prop: "id", label: "ID", width: 50 },
  { prop: "title", label: "Заголовок" },
  { prop: "site_section_name", label: "Раздел сайта" },
  { prop: "digest_name", label: "Дайджест" },
  { prop: "published", label: "Опубликовано", type: "bool", width: 140 },
  { prop: "created_at", label: "Дата создания", type: "datetime", width: 200 },
];

export default {
  components: {
    Content,
    Table,
  },
  data() {
    return {
      columnsOptions: { ...columnsOptions },
      columns,
      methods: {
        fetchData: this.fetchDataWithNames,
        deleteData: deletePublication,
      },
      filtersReady: false,
    };
  },
  async mounted() {
    try {
      const [siteSectionsResp, digestsResp] = await Promise.all([
        getSiteSections(),
        getDigests(),
      ]);
      const siteSections = siteSectionsResp.items || siteSectionsResp || [];
      const digests = digestsResp.items || digestsResp || [];

      const sectionValues = [
        { label: "Раздел", code: "" },
        ...siteSections.map((s) => ({ label: s.name, code: String(s.id) })),
      ];
      const digestValues = [
        { label: "Дайджест", code: "" },
        ...digests.map((d) => ({ label: d.name, code: String(d.id) })),
      ];

      const searchList = [...columnsOptions.search_list];
      const sectionIdx = searchList.findIndex(
        (s) => s.name === "site_section_id"
      );
      const digestIdx = searchList.findIndex((s) => s.name === "digest_id");
      if (sectionIdx !== -1) searchList[sectionIdx].values = sectionValues;
      if (digestIdx !== -1) searchList[digestIdx].values = digestValues;
      this.columnsOptions.search_list = searchList;
      this.filtersReady = true;
    } catch {
      this.filtersReady = true;
    }
  },
  methods: {
    async fetchDataWithNames(params) {
      const cleanParams = {};
      Object.keys(params || {}).forEach((key) => {
        const v = params[key];
        if (v === "" || v === undefined || v === null) return;
        if (
          key === "site_section_id" ||
          key === "digest_id" ||
          key === "publication_id"
        ) {
          const n = Number(v);
          if (!Number.isNaN(n)) cleanParams[key] = n;
        } else {
          cleanParams[key] = v;
        }
      });
      const response = await getPublications(cleanParams);
      const items = response.items || [];

      const [siteSectionsResp, digestsResp] = await Promise.all([
        getSiteSections(),
        getDigests(),
      ]);
      const siteSections = siteSectionsResp.items || siteSectionsResp || [];
      const digests = digestsResp.items || digestsResp || [];

      const siteSectionMap = {};
      siteSections.forEach((s) => {
        siteSectionMap[s.id] = s.name;
      });
      const digestMap = {};
      digests.forEach((d) => {
        digestMap[d.id] = d.name;
      });

      const itemsWithNames = items.map((item) => ({
        ...item,
        site_section_name:
          siteSectionMap[item.site_section] != null
            ? siteSectionMap[item.site_section]
            : `Раздел ${item.site_section}`,
        digest_name:
          digestMap[item.digest] != null
            ? digestMap[item.digest]
            : `Дайджест ${item.digest}`,
      }));

      return { items: itemsWithNames };
    },
  },
};
</script>
